"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adapter = void 0;

var NextArbitrary_1 = require("../../check/arbitrary/definition/NextArbitrary");

var NextValue_1 = require("../../check/arbitrary/definition/NextValue");

var Stream_1 = require("../../stream/Stream");

var AdaptedValue = Symbol('adapted-value');

function toAdapterNextValue(rawValue, adapter) {
  var adapted = adapter(rawValue.value_);

  if (!adapted.adapted) {
    return rawValue;
  }

  return new NextValue_1.NextValue(adapted.value, AdaptedValue);
}

var AdapterArbitrary = /*#__PURE__*/function (_NextArbitrary_1$Next) {
  _inherits(AdapterArbitrary, _NextArbitrary_1$Next);

  var _super = _createSuper(AdapterArbitrary);

  function AdapterArbitrary(sourceArb, adapter) {
    var _this;

    _classCallCheck(this, AdapterArbitrary);

    _this = _super.call(this);
    _this.sourceArb = sourceArb;
    _this.adapter = adapter;

    _this.adaptNextValue = function (rawValue) {
      return toAdapterNextValue(rawValue, adapter);
    };

    return _this;
  }

  _createClass(AdapterArbitrary, [{
    key: "generate",
    value: function generate(mrng, biasFactor) {
      var rawValue = this.sourceArb.generate(mrng, biasFactor);
      return this.adaptNextValue(rawValue);
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      return this.sourceArb.canShrinkWithoutContext(value) && !this.adapter(value).adapted;
    }
  }, {
    key: "shrink",
    value: function shrink(value, context) {
      if (context === AdaptedValue) {
        if (!this.sourceArb.canShrinkWithoutContext(value)) {
          return Stream_1.Stream.nil();
        }

        return this.sourceArb.shrink(value, undefined).map(this.adaptNextValue);
      }

      return this.sourceArb.shrink(value, context).map(this.adaptNextValue);
    }
  }]);

  return AdapterArbitrary;
}(NextArbitrary_1.NextArbitrary);

function adapter(sourceArb, adapter) {
  return new AdapterArbitrary(sourceArb, adapter);
}

exports.adapter = adapter;